import { trpc } from "@/lib/trpc";
import { toast } from "sonner";

export function useListDeletion() {
  const utils = trpc.useUtils();
  const listMutation = trpc.lists.remove.useMutation();
  const categoryMutation = trpc.categories.remove.useMutation();

  async function remove(
    kind: "list" | "category",
    id: number,
    name: string,
    onDeleted?: () => void
  ) {
    if (listMutation.isPending || categoryMutation.isPending) return;
    const consequence =
      kind === "category"
        ? "Its lists, tasks, and patterns will be kept. The lists will have no category."
        : "This permanently deletes the list and all its tasks and patterns, including task history.";
    if (!window.confirm(`Delete ${kind} "${name}"? ${consequence}`)) return;
    try {
      await (kind === "category" ? categoryMutation : listMutation).mutateAsync(
        { id }
      );
    } catch (error) {
      toast.error(
        error instanceof Error ? error.message : `Could not delete ${kind}`
      );
      return;
    }
    onDeleted?.();
    toast.success(`Deleted ${name}`);
    await Promise.all([
      utils.lists.invalidate(),
      utils.categories.invalidate(),
      utils.tasks.invalidate(),
      utils.templates.invalidate(),
    ]);
  }

  return {
    remove,
    isPending: listMutation.isPending || categoryMutation.isPending,
  };
}
